module.exports = __webpack_public_path__ + "static/media/Group 1499@3x.07cbfbc4.png";